import { render, staticRenderFns } from "./GBtableList.vue?vue&type=template&id=19f0f47e"
import script from "./GBtableList.vue?vue&type=script&lang=js"
export * from "./GBtableList.vue?vue&type=script&lang=js"
import style0 from "./GBtableList.vue?vue&type=style&index=0&id=19f0f47e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports